import {LqdCarouselHandler} from './lqd-carousel';

class LqdProductCarouselHandler extends LqdCarouselHandler {

}

export default ($element) => {
  elementorFrontend.elementsHandler.addHandler( LqdProductCarouselHandler, { $element } );
}; 